import type { ViewSDK } from '@salesforce/platform-sdk/view';

import { createContext, use } from 'react';

export const ViewSdkContext = createContext<null | ViewSDK>(null);

export const useViewSdk = (): ViewSDK => {
  const context = use(ViewSdkContext);
  if (!context) throw new Error('ViewSdkContext is not available');
  return context;
};
